import 'angular';

import '../api/api.module';
import '../core/core.module.ajs';
import '../messages/messages.module.ajs';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { CustomerActivityLogsComponent }          from './customer.activity-logs.component';
import { CustomerLiteCtrl }                       from './customer';
import { CustomerSelectionForAccountingLiteCtrl } from './customer.selection-for-accounting';
import { CustomersService }                       from './customers.service';
import { CustomerTypeFilter }                     from './customer.type.filter.ajs';
import { CustomerTypePipe }                       from './customer.type.pipe';

angular.module('app-lite.customers', [
  'app-lite.api',
  'app-lite.core',
  'app-lite.messages'
]).controller('CustomerLiteCtrl', CustomerLiteCtrl)
  .controller('CustomerSelectionForAccountingLiteCtrl', CustomerSelectionForAccountingLiteCtrl)
  .directive('worCustomerActivityLogs', downgradeComponent({ component: CustomerActivityLogsComponent }))
  .filter('customerType', CustomerTypeFilter)
  .service('customersApi', downgradeInjectable(CustomersService))
  .service('customerTypePipe', CustomerTypePipe);
